import {ReactComponent as dipIcon} from 'assets/icons/001-appetizer.svg'
import {ReactComponent as coffeeIcon} from 'assets/icons/coffee.svg'
import {ReactComponent as softDrinksIcon} from 'assets/icons/softdrink.svg'
import {ReactComponent as cocktailsIcon} from 'assets/icons/cocktail-2.svg'
import {ReactComponent as saladsIcon} from 'assets/icons/salad.svg'
import {ReactComponent as wineBottleIcon} from 'assets/icons/wineBottle.svg'
import {ReactComponent as wineGlassIcon} from 'assets/icons/wineglass.svg'
import {ReactComponent as beerIcon} from 'assets/icons/beer.svg'
import {ReactComponent as appetizerIcon} from 'assets/icons/appetizer.svg'
import {ReactComponent as dishIcon} from 'assets/icons/dish.svg'
import {ReactComponent as fishIcon} from 'assets/icons/006-seafood.svg'
import {ReactComponent as sweetIcon} from 'assets/icons/009-desserts.svg'
import {ReactComponent as alcoholIcon} from 'assets/icons/whiskey.svg'
import {ReactComponent as infoIcon} from 'assets/icons/info.svg'
import {ReactComponent as ouzoIcon} from 'assets/icons/ouza.svg'
import {ReactComponent as tispouroIcon} from 'assets/icons/tsipouro.svg'
import {ReactComponent as chocolateIcon} from 'assets/icons/chocolate.svg'
import {ReactComponent as icecreamIcon} from 'assets/icons/ice-cream.svg'
import {ReactComponent as snackIcon} from 'assets/icons/snack.svg'
import {ReactComponent as brunchIcon} from 'assets/icons/pancakes.svg'
import {ReactComponent as kebapIcon} from 'assets/icons/kebab.svg'
// import {ReactComponent as champagneIcon} from 'assets/icons/champagne.svg'
// import {ReactComponent as whiskeyIcon} from 'assets/icons/whiskey.svg'
// import {ReactComponent as fishIcon} from 'assets/icons/fish.svg'
// import {ReactComponent as sandwichesIcon} from 'assets/icons/sandwich.svg'
// import {ReactComponent as snackIcon} from 'assets/icons/snack.svg'
// import {ReactComponent as burgerIcon} from 'assets/icons/hamburger.svg'
// import {ReactComponent as pizzaIcon} from 'assets/icons/pizza.svg'
// import {ReactComponent as pastaIcon} from 'assets/icons/pasta.svg'
// import {ReactComponent as breakfastIcon} from 'assets/icons/breakfast.svg'


export const categoryIcons = [
  {id:1,component:appetizerIcon},
  {id:2,component:saladsIcon},
  {id:3,component:appetizerIcon},
  {id:4,component:saladsIcon},
  {id:5,component:dishIcon},
  {id:6,component:fishIcon},
  {id:7,component:fishIcon},
  {id:8,component:wineGlassIcon},
  {id:9,component:beerIcon},
  {id:10,component:ouzoIcon},
  {id:11,component:tispouroIcon},
  {id:12,component:softDrinksIcon},
  {id:13,component:softDrinksIcon},
  {id:14,component:alcoholIcon},
  {id:15,component:sweetIcon},
  {id:16,component:coffeeIcon},
  {id:17,component:dipIcon},
  {id:18,component:wineBottleIcon},
  {id:19,component:infoIcon},
  {id:20,component:cocktailsIcon},
  {id:21,component:chocolateIcon},
  {id:22,component:icecreamIcon},
  {id:23,component:snackIcon}
  ]
